var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"userhome",attrs:{"type":"flex","justify":"center","align":"top"}},[_c('a-col',{attrs:{"span":4}},[_c('Usernav',{staticClass:"nav"})],1),_vm._v(" "),_c('a-col',{staticStyle:{"margin-left":"5em"},attrs:{"span":18}},[_c('bread'),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c192b06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userindex.vue
// module id = null
// module chunks = 